import isEmpty from 'lodash/isEmpty';

import fetchItems from './fetchItems';
import resetForm from './resetForm';
import toggleProductForm from './toggleProductForm';

export default (filterData = {}) =>
    (dispatch) => {
        if (!isEmpty(filterData)) dispatch(fetchItems(filterData));
        dispatch(resetForm());
        dispatch(toggleProductForm(false));
    };
